<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
          class="form"
        >
          <van-field 
            required  
            label="背景图"
            v-model="questionPage.questionBackImg"
            :rules="[{ required: true, message: '请上传背景图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="questionPage.questionBackImgArr" 
                :after-read="(e) => uploadImg(e, 'questionBackImg')"
                @delete="(e) => deleteImg('questionBackImg')"
              />
            </template>
          </van-field>
          <van-field 
            required  
            label="题目图"
            v-model="questionPage.questionImg"
            :rules="[{ required: true, message: '请上题目图' }]"
          >
            <template #input>
              <van-uploader
                :max-count="1" 
                :before-read="beforeImgUpload" 
                :fileList="questionPage.questionImgArr" 
                :after-read="(e) => uploadImg(e, 'questionImg')"
                @delete="(e) => deleteImg('questionImg')"
              />
            </template>
          </van-field>
          <template v-for="(item,index) in questionPage.answersArr">
            <van-field
              :key="index"
              required  
              :label="`答案${index== 0 ? 'A' : index== 1 ? 'B' : index== 2 ? 'C': 'D'}`"
              v-model="item.img.url"
              :rules="[{ required: true, message: `请上传答案${index== 0 ? 'A' : index== 1 ? 'B' : index== 2 ? 'C': 'D'}` }]"
            >
              <template #input>
                <van-uploader
                  :max-count="1" 
                  :before-read="beforeImgUpload" 
                  :fileList="item.img"
                  :after-read="(e) => uploadImgBtn(e,index)"
                  @delete="(e) => deleteImgBtn(index)"
                />
              </template>
            </van-field>
          </template>
          <div 
            class="btn-box" 
            v-if="questionPage.answersArr && questionPage.answersArr.length < 4" 
            @click="addBtn"
          >
            添加答案
          </div>
          <div 
            class="btn-box" 
            v-if="questionPage.answersArr && questionPage.answersArr.length > 1" 
            @click="detBtn"
          >
            删除答案
          </div>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">保存</div>
        </div>
        <div style="height:66px"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import _ from 'loadsh'
export default {
  props: {
    isAddAnswer: {
      type: Boolean,
      default: false
    },
    questionPage: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    showPop: {
      get() {
        return this.isAddAnswer
      },
      set(val) {
        this.$emit('update:isAddAnswer', val)
      }
    },
    from() {
      return this.$route.query.from
    }
  },
  data() {
    return {
      isUploadImg: false,
      headImgList: [],
      debounce:  _.debounce(this.checkParames,1500)
    }
  },
  
  methods: {
    onCancel() {
      this.isPicker = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e, field) {
      this.uploadImgFn(e, field)
    },
    uploadImgFn(e, field) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.questionPage[`${field}Arr`].push(currentFile)
      this.$api.common.uploadImg(e.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            this.questionPage[field] = fileUrl
            currentFile.status = 'done'
            delete currentFile.status
            delete currentFile.message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.questionPage[field] = []
          this.questionPage[`${field}Arr`] = ''
      });
    },
    deleteImg(field) {
      this.questionPage[field] = ''
      this.questionPage[`${field}Arr`] = []
    },
  
    uploadImgBtn(e,index) {
      this.uploadImgBtnFn(e,index)
    },
    uploadImgBtnFn(e, index) {
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.questionPage.answersArr[index].img.push(currentFile)
      this.$api.common.uploadImg(e.file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            this.questionPage.answers[index] = fileUrl
            currentFile.status = 'done'
            delete currentFile.status
            delete currentFile.message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.questionPage.answersArr[index].img = []
      });
    },
    deleteImgBtn(index) {
      this.questionPage.answersArr.splice(index, 1)
      this.questionPage.answers.splice(index, 1)
    },
    addBtn() {
      this.questionPage.answersArr.push({img: []})
    },
    detBtn() {
      let index = this.questionPage.answersArr.length -1
      this.deleteImgBtn(index)
    },
    checkParames() {
      // 图片上传中
      if (this.isUploadImg) return
      this.$refs.form.validate().then(async res => {
          if (this.from == 'manager') {
            const {activityId,id=''} = this.questionPage
            const res = await this.$api.typeTest.saveStylePage({
              id,
              activityId,
              pageType: 'question',
              pageMap:this.questionPage
            })
            this.questionPage.id = res.data ? res.data : id
          }
          this.$emit('questionPageSaveSuccess', this.questionPage)
          this.$toast('保存成功');
          this.showPop = false
        }).catch(err => {
          this.$toast(err[0].message);
        })
    },
    submit() {
      this.debounce()
    },
    cancel() {
      this.showPop = false
    },
  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
.content {
  .form {
    max-height: 70vh;
    overflow: hidden;
    overflow-y: auto;
    .btn-box {
      margin 10px 15px
      padding 6px 0
      text-align: center
      color $mainTextColor
      font-size 14px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 8px
    }
  }
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .serial-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #606266;
    font-weight: 600;
    height: 30px;
    margin: 0 15px;
    .replace {
      color: #ff6b31;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  .h5-cropper {
    position: absolute;
    left: -1000px;
    background: red;
  }
}
</style>